import { Controller } from "stimulus"

export default class extends Controller {
  reset() {
    // Turbo snapshots the live DOM, and cloning an input copies the value the user typed.
    // Reset the form to the server-rendered query, so a restore visit does not show a
    // search box that disagrees with the results below it.
    this.element.reset()
  }
}
